import { render, staticRenderFns } from "./s-finance.vue?vue&type=template&id=1eda2dec&"
import script from "./s-finance.vue?vue&type=script&lang=js&"
export * from "./s-finance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports